module.exports = __webpack_public_path__ + "img/logo-dark.3492ac76.svg";